var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetecbannerwithlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000111174029125040059430000012689806496809548976_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000125597211355551720730000014109417235807211438_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000145018612802057992670000016818903290915673217_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000177472744315388968220000017773665730877647495_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_00000044172457900802200430000001195649251937189521_);fill:#FFFFFF;}\n\t.st5{clip-path:url(#SVGID_00000133498257658861992330000014416501202663982497_);fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_00000031192434363393626960000016723015713336999582_);fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_00000105415571206528648510000006427881085516338615_);fill:#FFFFFF;}\n\t.st8{clip-path:url(#SVGID_00000011720374893857804870000009845052502250111155_);fill:#FFFFFF;}\n\t.st9{clip-path:url(#SVGID_00000038375900777860103350000002206853839143396748_);fill:#FFFFFF;}\n\t.st10{clip-path:url(#SVGID_00000105417608547210867040000011380661156749023390_);fill:#FFFFFF;}\n\t.st11{clip-path:url(#SVGID_00000152262759485043707650000003887749889803131045_);fill:#FFFFFF;}\n\t.st12{clip-path:url(#SVGID_00000114043736467766494340000011633007405698395828_);fill:#FFFFFF;}\n\t.st13{clip-path:url(#SVGID_00000057122410169852982310000005331659818303590811_);fill:#FFFFFF;}\n\t.st14{clip-path:url(#SVGID_00000030446195200442711230000009110151932263974332_);fill:#FFFFFF;}\n\t.st15{clip-path:url(#SVGID_00000121275166534227550630000005227704440786799286_);fill:#FFFFFF;}\n\t.st16{clip-path:url(#SVGID_00000156570841329028341880000006187038704965093774_);fill:#FFFFFF;}\n\t.st17{clip-path:url(#SVGID_00000041273516533216454710000004074849938295446178_);fill:#FFFFFF;}\n\t.st18{clip-path:url(#SVGID_00000160161349487006991070000001810888501234413450_);fill:#FFFFFF;}\n\t.st19{clip-path:url(#SVGID_00000086693686018157220750000016866156196733597346_);fill:#FFFFFF;}\n\t.st20{clip-path:url(#SVGID_00000142139175196759024000000013453420296452640427_);fill:#FFFFFF;}\n\t.st21{clip-path:url(#SVGID_00000055704895178660854000000014142902989599593147_);fill:#FFFFFF;}\n\t.st22{clip-path:url(#SVGID_00000001659311520835288320000014951517467090970527_);fill:#FFFFFF;}\n\t.st23{clip-path:url(#SVGID_00000027606382951030702250000003660103571063496841_);fill:#FFFFFF;}\n\t.st24{clip-path:url(#SVGID_00000147917098409748753910000004967305458577858221_);fill:#FFFFFF;}\n\t.st25{clip-path:url(#SVGID_00000066487681220900993350000008085880999213844877_);fill:#FFFFFF;}\n\t.st26{clip-path:url(#SVGID_00000033359293490430750510000000365936944649280174_);fill:#FFFFFF;}\n\t.st27{clip-path:url(#SVGID_00000109025711301436340760000004844917964763882909_);fill:#FFFFFF;}\n\t.st28{clip-path:url(#SVGID_00000145016128095405367170000010778014959912599211_);fill:#FFFFFF;}\n\t.st29{clip-path:url(#SVGID_00000059302362960125801300000017824628222465843093_);fill:#FFFFFF;}\n\t.st30{clip-path:url(#SVGID_00000090978281548186222420000001387405739048991644_);fill:#FFFFFF;}\n\t.st31{clip-path:url(#SVGID_00000049180600444590905230000010555339280383785857_);fill:#FFFFFF;}\n\t.st32{clip-path:url(#SVGID_00000171687304012666651720000007600272604179578777_);fill:#FFFFFF;}\n\t.st33{clip-path:url(#SVGID_00000088117223886987574880000005902080345333169540_);fill:#FFFFFF;}\n\t.st34{clip-path:url(#SVGID_00000119086676755875174130000009950062990866654898_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "287.6,30 287.6,280.4 538.3,530.7 538.3,280.4  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165232630961513542350000006543572930177621888_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 286.1,
    y: 28.5,
    style: {
      clipPath: "url(#SVGID_00000165232630961513542350000006543572930177621888_)",
      fill: "#FFFFFF"
    },
    width: 253.6,
    height: 503.8
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175314101914630119960000005101041345863368127_",
    points: "538.3,30 538.3,280.4 788.9,530.7 788.9,280.4  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175314101914630119960000005101041345863368127_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008838450624031978040000015359962397387023773_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175314101914630119960000005101041345863368127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 536.8,
    y: 28.5,
    style: {
      clipPath: "url(#SVGID_00000008838450624031978040000015359962397387023773_)",
      fill: "#FFFFFF"
    },
    width: 253.6,
    height: 503.8
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090279696089985634510000002444011131997246115_",
    x: 37,
    y: 280.4,
    width: 250.6,
    height: 250.4
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090279696089985634510000002444011131997246115_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016763606292212443240000011012327084292155066_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090279696089985634510000002444011131997246115_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 278.8,
    style: {
      clipPath: "url(#SVGID_00000016763606292212443240000011012327084292155066_)",
      fill: "#FFFFFF"
    },
    width: 253.6,
    height: 253.4
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088830385539859270110000007314513390187611787_",
    points: "67.9,738.9 66.6,718.2 67.7,718.2 92.4,756.9  97.5,756.9 121.1,718.2 122.4,718.2 121.3,741.2 121.3,820.1 150.3,820.1 150.3,672.1 121.1,672.1 96,713.1 95.1,713.1  69.8,672.1 40.4,672.1 40.4,820.1 67.9,820.1  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088830385539859270110000007314513390187611787_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167355368579563852640000007126524221415646380_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088830385539859270110000007314513390187611787_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 670.6,
    style: {
      clipPath: "url(#SVGID_00000167355368579563852640000007126524221415646380_)",
      fill: "#FFFFFF"
    },
    width: 112.8,
    height: 151.1
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070092068156855753420000005625392676965364146_",
    points: "272.5,794.3 203.1,794.3 203.1,758.1  266.2,758.1 266.2,732.3 203.1,732.3 203.1,697.9 271.5,697.9 271.5,672.1 174,672.1 174,820.1 272.5,820.1  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070092068156855753420000005625392676965364146_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157283594196054454640000014083225686959822013_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070092068156855753420000005625392676965364146_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.5,
    y: 670.6,
    style: {
      clipPath: "url(#SVGID_00000157283594196054454640000014083225686959822013_)",
      fill: "#FFFFFF"
    },
    width: 101.5,
    height: 151.1
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000042706114785357837650000007325675231451372472_",
    points: "399.4,794.3 329.9,794.3 329.9,758.1 393,758.1  393,732.3 329.9,732.3 329.9,697.9 398.3,697.9 398.3,672.1 300.9,672.1 300.9,820.1 399.4,820.1  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042706114785357837650000007325675231451372472_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020370040595286588250000016073748420454454463_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042706114785357837650000007325675231451372472_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 670.6,
    style: {
      clipPath: "url(#SVGID_00000020370040595286588250000016073748420454454463_)",
      fill: "#FFFFFF"
    },
    width: 101.5,
    height: 151.1
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013897176574908306690000012510348295405925007_",
    d: "M437.3,768.5c0,19.1,4,33.1,12,41.8 c8,8.8,19.9,13.2,35.6,13.2c4.4,0,8.8-0.5,13.3-1.5c4.5-1,8.8-2.4,13-4.1c4.2-1.7,8-3.8,11.6-6.1c3.6-2.3,6.6-4.9,9-7.7l-12.7-19 c-1.7,1.4-3.6,3-5.6,4.6c-2.1,1.7-4.3,3.2-6.8,4.6c-2.5,1.4-5.3,2.6-8.4,3.5c-3.1,0.9-6.6,1.4-10.4,1.4c-7.3,0-13-2.4-17.1-7.3 c-4.1-4.8-6.1-12.7-6.1-23.5v-30.1h55.4v-23.2h-55.4v-31.8l-27.5,7.8v24h-20.9v23.2h20.9L437.3,768.5L437.3,768.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013897176574908306690000012510348295405925007_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098934939726087183330000006634532918232240771_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013897176574908306690000012510348295405925007_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 414.8,
    y: 681.9,
    style: {
      clipPath: "url(#SVGID_00000098934939726087183330000006634532918232240771_)",
      fill: "#FFFFFF"
    },
    width: 118.5,
    height: 143.1
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000109008433012802289870000006063301271034525863_",
    d: "M582.1,746.8c1.7-2.9,3.8-5.3,6.4-7.2 c2.6-1.9,5.5-3.4,8.7-4.4c3.2-1,6.7-1.5,10.3-1.5c7.9,0,13.7,2.1,17.6,6.1c3.9,4.1,5.8,9.7,5.8,16.7h-51.8 C579.4,753,580.4,749.7,582.1,746.8z M566.3,808.6c4.9,4.9,10.9,8.6,18,11.1c7.1,2.5,15.1,3.8,24.1,3.8c5.2,0,10.1-0.4,14.7-1.3 c4.6-0.8,8.9-2,12.7-3.4c3.9-1.4,7.2-2.9,10.1-4.6c2.9-1.6,5.2-3.3,7.1-5l-9.1-18c-3.4,2.8-7.8,5.2-13.2,7.2c-5.4,2-12.3,3-20.7,3 c-4.2,0-8.2-0.5-11.9-1.4c-3.7-0.9-7-2.4-9.9-4.4c-2.9-2-5.2-4.5-7-7.6c-1.8-3.1-2.7-6.9-2.8-11.4h75.8c1.4-7.1,2.1-13.6,2.1-19.7 c0-8.9-1.5-16.2-4.5-22c-3-5.8-6.9-10.4-11.7-13.9c-4.8-3.5-10-5.9-15.7-7.3c-5.7-1.4-11.2-2.1-16.5-2.1c-8,0-15.4,1.2-22.3,3.5 c-6.9,2.3-12.9,5.8-18,10.5c-5.1,4.7-9.2,10.5-12.1,17.5c-2.9,7-4.4,15.1-4.4,24.5c0,8.8,1.3,16.6,3.9,23.4 C557.6,797.8,561.4,803.7,566.3,808.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109008433012802289870000006063301271034525863_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077311924460280541530000011173042703493124003_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109008433012802289870000006063301271034525863_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 549.6,
    y: 710.1,
    style: {
      clipPath: "url(#SVGID_00000077311924460280541530000011173042703493124003_)",
      fill: "#FFFFFF"
    },
    width: 108.3,
    height: 114.9
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034087860875648847770000008056181034688918414_",
    d: "M695.1,808.2c4.9,4.9,10.9,8.7,18,11.3 c7.1,2.7,15.3,4,24.4,4c8.5,0,16.6-1.1,24.3-3.3c7.7-2.2,14.5-5.5,20.3-9.9l-9.1-20.6c-2.5,1.7-6.4,3.7-11.5,5.9 c-5.1,2.3-11.7,3.4-19.8,3.4c-5.1,0-9.7-0.8-13.9-2.4c-4.2-1.6-7.7-3.9-10.5-6.7c-2.8-2.8-5-6.2-6.6-10c-1.6-3.8-2.3-8-2.3-12.5 c0-5.5,1-10.2,2.9-14.2c1.9-3.9,4.4-7.2,7.4-9.9c3-2.6,6.5-4.5,10.4-5.7c3.9-1.2,7.8-1.8,11.7-1.8c4.4,0,8.7,0.5,13.1,1.5V757 h23.3v-37.3c-3.7-1.7-9-3.5-15.9-5.3c-6.9-1.8-14.3-2.8-22.2-2.8c-8.5,0-16.3,1.2-23.5,3.7c-7.2,2.5-13.4,6.1-18.7,10.9 c-5.3,4.8-9.4,10.7-12.4,17.6c-3,6.9-4.4,14.8-4.4,23.7c0,8.3,1.3,16,3.8,22.9C686.5,797.4,690.2,803.3,695.1,808.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034087860875648847770000008056181034688918414_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150080079467432239480000010336425617461407388_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034087860875648847770000008056181034688918414_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 678.7,
    y: 710.1,
    style: {
      clipPath: "url(#SVGID_00000150080079467432239480000010336425617461407388_)",
      fill: "#FFFFFF"
    },
    width: 104.9,
    height: 114.9
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000119080648850190503150000005529144594240804234_",
    points: "89.2,960.3 101.6,960.3 101.6,907.1 79.6,907.1  71.5,951.5 63.5,907.1 41.6,907.1 41.6,960.3 53.9,960.3 53.9,915.4 63.3,960.3 80,960.3 89.2,915.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119080648850190503150000005529144594240804234_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098181078973282205960000009307468934509866928_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119080648850190503150000005529144594240804234_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 905.6,
    style: {
      clipPath: "url(#SVGID_00000098181078973282205960000009307468934509866928_)",
      fill: "#FFFFFF"
    },
    width: 63,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070094304776742755730000011633694230461488045_",
    points: "143.5,916.9 143.5,907.1 109.5,907.1  109.5,960.3 143.5,960.3 143.5,950.5 122.7,950.5 122.7,938.5 139.4,938.5 139.4,928.8 122.7,928.8 122.7,916.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070094304776742755730000011633694230461488045_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067943321799845796800000008775089120918576545_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070094304776742755730000011633694230461488045_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 905.6,
    style: {
      clipPath: "url(#SVGID_00000067943321799845796800000008775089120918576545_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099649453379674025490000004608361067755752373_",
    d: "M189,954.5c1.8-2,3.2-4.3,4.1-6.7 c0.9-2.5,1.3-4.9,1.3-7.2h-12.9c0,1.5-0.2,2.8-0.6,4.1c-0.4,1.3-1,2.4-1.8,3.4c-0.8,1-1.8,1.8-3,2.3c-1.2,0.6-2.5,0.8-4,0.8 c-2.1,0-4-0.6-5.6-1.9c-1.6-1.2-3-3.2-3.9-5.7s-1.5-5.9-1.5-10c0-4,0.5-7.4,1.5-9.9c1-2.6,2.3-4.5,3.9-5.7 c1.6-1.2,3.5-1.8,5.6-1.8c1.8,0,3.3,0.4,4.6,1.1c1.3,0.7,2.3,1.7,3.1,3c0.8,1.3,1.3,2.7,1.5,4.4c0.1,0.6,0.1,1.3,0.1,2.1h12.9 c0-1.6-0.2-3.3-0.7-5.1c-0.7-2.7-1.9-5.2-3.7-7.6c-1.8-2.4-4.2-4.4-7.2-5.8c-3-1.5-6.6-2.2-10.8-2.2c-5.1,0-9.4,1.2-13,3.5 c-3.6,2.4-6.4,5.6-8.3,9.8c-1.9,4.1-2.8,8.9-2.8,14.4c0,5.4,0.9,10.2,2.8,14.4c1.9,4.2,4.6,7.4,8.3,9.8c3.6,2.4,7.9,3.5,13,3.5 c3.8,0,7.1-0.6,9.9-1.9C184.8,958.3,187.1,956.6,189,954.5L189,954.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099649453379674025490000004608361067755752373_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129918580399777431850000014350821936928705666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099649453379674025490000004608361067755752373_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 904.5,
    style: {
      clipPath: "url(#SVGID_00000129918580399777431850000014350821936928705666_)",
      fill: "#FFFFFF"
    },
    width: 49.4,
    height: 58.4
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168108822404903735570000014752419055427558845_",
    points: "201.2,907.1 201.2,960.3 214.3,960.3  214.3,938.7 232.3,938.7 232.3,960.3 245.4,960.3 245.4,907.1 232.3,907.1 232.3,929 214.3,929 214.3,907.1  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168108822404903735570000014752419055427558845_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018944555132775096070000011463350105275557514_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168108822404903735570000014752419055427558845_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.7,
    y: 905.6,
    style: {
      clipPath: "url(#SVGID_00000018944555132775096070000011463350105275557514_)",
      fill: "#FFFFFF"
    },
    width: 47.2,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029032047347962777330000003833584086639789959_",
    points: "287.3,916.9 287.3,907.1 253.3,907.1  253.3,960.3 287.3,960.3 287.3,950.5 266.5,950.5 266.5,938.5 283.2,938.5 283.2,928.8 266.5,928.8 266.5,916.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029032047347962777330000003833584086639789959_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028325293910584226940000017766141826942261147_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029032047347962777330000003833584086639789959_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.8,
    y: 905.6,
    style: {
      clipPath: "url(#SVGID_00000028325293910584226940000017766141826942261147_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057122619523897123560000003354288806902802328_",
    points: "295.2,907.1 295.2,960.3 328,960.3 328,949.9  308.3,949.9 308.3,907.1  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057122619523897123560000003354288806902802328_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082359227736385627920000018349324504516442263_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057122619523897123560000003354288806902802328_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 905.6,
    style: {
      clipPath: "url(#SVGID_00000082359227736385627920000018349324504516442263_)",
      fill: "#FFFFFF"
    },
    width: 35.8,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000088837520313686437180000007197181207573434002_",
    d: "M352.9,961.4c4,0,7.5-0.6,10.6-1.8 c3.1-1.2,5.5-2.9,7.2-5.2c1.7-2.3,2.6-5.1,2.6-8.4s-0.7-5.8-2-7.8c-1.3-2-3.2-3.7-5.6-5.1c-2.4-1.4-5.2-2.6-8.5-3.7 c-2.3-0.8-4.3-1.6-6-2.3c-1.8-0.7-3.2-1.6-4.2-2.5c-1-0.9-1.5-2-1.5-3.2c0-1.7,0.7-3.1,2-3.9c1.3-0.9,3.2-1.3,5.6-1.3 c2.4,0,4.3,0.6,5.3,1.8c1.1,1.2,1.6,2.7,1.6,4.7v1.4h13v-2c0-3.5-0.9-6.4-2.6-8.8c-1.7-2.4-4.1-4.2-7.2-5.4 c-3-1.2-6.5-1.8-10.3-1.8s-7.1,0.6-10.1,1.8c-3,1.2-5.4,3-7.1,5.3c-1.8,2.3-2.6,5.1-2.6,8.3c0,3.2,0.7,5.8,2.1,8 c1.4,2.1,3.3,3.9,5.5,5.3c2.3,1.4,4.7,2.5,7.4,3.3c2.4,0.7,4.6,1.5,6.5,2.3s3.4,1.8,4.6,2.7c1.1,1,1.7,2.1,1.7,3.3 c0,1.7-0.7,3-2,3.7c-1.3,0.8-3.3,1.1-5.7,1.1c-2.4,0-4.3-0.6-5.5-1.9c-1.2-1.2-1.8-2.9-1.8-5v-1.7h-13v2c0,3.7,0.9,6.8,2.6,9.3 c1.7,2.5,4.1,4.4,7.2,5.6C345.4,960.8,348.9,961.4,352.9,961.4L352.9,961.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088837520313686437180000007197181207573434002_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067212038729433302880000005578672017795094429_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088837520313686437180000007197181207573434002_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 331.1,
    y: 904.5,
    style: {
      clipPath: "url(#SVGID_00000067212038729433302880000005578672017795094429_)",
      fill: "#FFFFFF"
    },
    width: 43.8,
    height: 58.4
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085955139385555164030000015207488934739405709_",
    points: "414.1,916.9 414.1,907.1 380.1,907.1  380.1,960.3 414.1,960.3 414.1,950.5 393.3,950.5 393.3,938.5 410,938.5 410,928.8 393.3,928.8 393.3,916.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085955139385555164030000015207488934739405709_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152949998447517857630000008851404144419564965_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085955139385555164030000015207488934739405709_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 378.6,
    y: 905.6,
    style: {
      clipPath: "url(#SVGID_00000152949998447517857630000008851404144419564965_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000001644968161931667390000010047390899795337358_",
    points: "41.6,1030.3 75.5,1030.3 75.5,1020.6  54.7,1020.6 54.7,1008.6 71.5,1008.6 71.5,998.8 54.7,998.8 54.7,987 75.5,987 75.5,977.2 41.6,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001644968161931667390000010047390899795337358_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173869930715122697750000013809581319075987611_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001644968161931667390000010047390899795337358_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000173869930715122697750000013809581319075987611_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039134666169368197730000004948560853169013175_",
    points: "117.3,1019.1 103.3,977.2 83.4,977.2  83.4,1030.3 96,1030.3 96,989.2 109.8,1030.3 129.9,1030.3 129.9,977.2 117.3,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039134666169368197730000004948560853169013175_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061432729066077604460000003152990610593508283_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039134666169368197730000004948560853169013175_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000061432729066077604460000003152990610593508283_)",
      fill: "#FFFFFF"
    },
    width: 49.4,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067944525824600697610000005835051371363651484_",
    points: "137.8,1030.3 171.8,1030.3 171.8,1020.6  151,1020.6 151,1008.6 167.7,1008.6 167.7,998.8 151,998.8 151,987 171.8,987 171.8,977.2 137.8,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067944525824600697610000005835051371363651484_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019651137136231918580000014728953117565634715_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067944525824600697610000005835051371363651484_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.3,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000019651137136231918580000014728953117565634715_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070116951677451060490000002255342862547175089_",
    d: "M205.3,997.2c-0.6,1.1-1.4,1.9-2.4,2.5 c-1,0.6-2.2,0.9-3.5,0.9h-7.1v-13.6h6.9c2.2,0,3.9,0.6,5.1,1.8c1.2,1.2,1.9,2.8,1.9,4.7C206.1,994.8,205.9,996.1,205.3,997.2 L205.3,997.2z M217.8,999.1c1-1.9,1.5-4.2,1.5-7c0-4.8-1.4-8.4-4.2-11c-2.8-2.6-7.1-3.9-12.9-3.9h-22.5v53.1h12.5v-20.1h6.9 c2.3,0,3.8,0.6,4.8,1.7c0.9,1.1,1.4,2.7,1.4,4.7v8c0,1.2,0.1,2.3,0.3,3.4c0.2,1,0.5,1.8,0.8,2.4h12.8c-0.4-0.5-0.7-1.3-0.9-2.3 c-0.2-1.1-0.3-2.2-0.3-3.4v-9.5c0-2.3-0.4-4.2-1.2-5.6c-0.8-1.4-1.9-2.4-3.2-3.1c-1.3-0.6-2.7-1-4.3-1.1c1.5-0.1,3-0.7,4.5-1.7 C215.5,1002.5,216.7,1001.1,217.8,999.1L217.8,999.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070116951677451060490000002255342862547175089_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070804241496027322110000016478906794979443595_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070116951677451060490000002255342862547175089_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178.2,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000070804241496027322110000016478906794979443595_)",
      fill: "#FFFFFF"
    },
    width: 42.6,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116941866288146977480000016176679709069441215_",
    d: "M266.7,982.6c-1.7-1.9-3.8-3.5-6.5-4.7 c-2.7-1.2-5.9-1.8-9.7-1.8c-4.5,0-8.6,1.1-12.3,3.2c-3.7,2.2-6.6,5.3-8.8,9.4c-2.2,4.1-3.3,9.2-3.3,15.2c0,6,1,11,3.1,15.1 c2.1,4.1,4.8,7.2,8.3,9.3s7.4,3.1,11.6,3.1c2.5,0,4.6-0.3,6.3-0.8c1.8-0.5,3.2-1.1,4.4-1.9c1.1-0.8,2-1.5,2.7-2.3 c0.6-0.8,1-1.4,1.2-1.9l1.2,5.9h6.3v-27.4h-20.9v9.2h9.6v2.8c-0.2,0.9-0.7,1.9-1.5,2.8c-0.8,1-1.9,1.8-3.2,2.4c-1.3,0.7-3,1-4.9,1 c-1.4,0-2.7-0.3-4.1-0.8c-1.3-0.5-2.5-1.5-3.6-2.8c-1.1-1.3-1.9-3.1-2.6-5.3c-0.6-2.2-1-5.1-1-8.4c0-4.5,0.6-8,1.7-10.6 s2.6-4.4,4.3-5.5c1.7-1.1,3.5-1.6,5.4-1.6c1.4,0,2.6,0.2,3.6,0.7c1,0.5,1.9,1.1,2.7,1.9c0.7,0.8,1.3,1.6,1.7,2.6 c0.4,1,0.6,2,0.6,3v0.4h12.4v-0.4c0-1.7-0.4-3.7-1.1-5.8C269.5,986.6,268.3,984.5,266.7,982.6L266.7,982.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116941866288146977480000016176679709069441215_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140016661833720061360000002715764608162051004_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116941866288146977480000016176679709069441215_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 224.6,
    y: 974.6,
    style: {
      clipPath: "url(#SVGID_00000140016661833720061360000002715764608162051004_)",
      fill: "#FFFFFF"
    },
    width: 48.3,
    height: 58.4
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173869490966888378270000000667322543163419574_",
    x: 279.3,
    y: 977.2,
    width: 12.5,
    height: 53.1
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173869490966888378270000000667322543163419574_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061437278822180943590000007407141272777843869_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173869490966888378270000000667322543163419574_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 277.8,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000061437278822180943590000007407141272777843869_)",
      fill: "#FFFFFF"
    },
    width: 15.5,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173860731977200668850000016944020859348606878_",
    points: "300.9,1030.3 334.8,1030.3 334.8,1020.6  314,1020.6 314,1008.6 330.8,1008.6 330.8,998.8 314,998.8 314,987 334.8,987 334.8,977.2 300.9,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173860731977200668850000016944020859348606878_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074420062680695043690000007353719368759856567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173860731977200668850000016944020859348606878_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000074420062680695043690000007353719368759856567_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000161619914390329005710000016287784912802272404_",
    points: "340.5,987 353.3,987 353.3,1030.3 366.2,1030.3  366.2,987 379,987 379,977.2 340.5,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161619914390329005710000016287784912802272404_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155840395415952791050000013795587045560582018_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161619914390329005710000016287784912802272404_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000155840395415952791050000013795587045560582018_)",
      fill: "#FFFFFF"
    },
    width: 41.5,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071536250814333395490000005856796402118427794_",
    points: "385.8,1030.3 419.8,1030.3 419.8,1020.6  398.9,1020.6 398.9,1008.6 415.7,1008.6 415.7,998.8 398.9,998.8 398.9,987 419.8,987 419.8,977.2 385.8,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071536250814333395490000005856796402118427794_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018918572765738201750000009631009866562383293_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071536250814333395490000005856796402118427794_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 384.3,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000018918572765738201750000009631009866562383293_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170263776555740567940000006205731405626197691_",
    d: "M441.6,988.1c1.6-1.2,3.5-1.8,5.6-1.8 c1.8,0,3.3,0.4,4.6,1.1c1.3,0.7,2.3,1.7,3.1,3c0.8,1.3,1.3,2.7,1.5,4.4c0.1,0.6,0.1,1.3,0.1,2.1h12.9c0-1.6-0.2-3.3-0.7-5.1 c-0.7-2.7-1.9-5.2-3.7-7.6c-1.8-2.4-4.2-4.4-7.2-5.8c-3-1.5-6.6-2.2-10.8-2.2c-5.1,0-9.4,1.2-13,3.5s-6.4,5.6-8.3,9.8 c-1.9,4.1-2.8,8.9-2.8,14.4s0.9,10.2,2.8,14.4c1.9,4.2,4.6,7.4,8.3,9.8c3.6,2.4,7.9,3.5,13,3.5c3.8,0,7.1-0.6,9.9-1.9 c2.8-1.3,5.1-2.9,6.9-5c1.8-2,3.2-4.3,4.1-6.7c0.9-2.5,1.3-4.9,1.3-7.2h-12.9c0,1.5-0.2,2.8-0.6,4.1c-0.4,1.3-1,2.4-1.8,3.4 c-0.8,1-1.8,1.8-3,2.3c-1.2,0.6-2.5,0.8-4,0.8c-2.1,0-4-0.6-5.6-1.9s-3-3.2-3.9-5.7c-1-2.6-1.5-5.9-1.5-10s0.5-7.4,1.5-9.9 C438.7,991.3,440,989.4,441.6,988.1L441.6,988.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170263776555740567940000006205731405626197691_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051348863984414880340000000689612542075027350_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170263776555740567940000006205731405626197691_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 421.6,
    y: 974.6,
    style: {
      clipPath: "url(#SVGID_00000051348863984414880340000000689612542075027350_)",
      fill: "#FFFFFF"
    },
    width: 49.4,
    height: 58.4
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000162344701534152703020000012320712931880276159_",
    points: "507.4,999 489.5,999 489.5,977.2 476.4,977.2  476.4,1030.3 489.5,1030.3 489.5,1008.8 507.4,1008.8 507.4,1030.3 520.5,1030.3 520.5,977.2 507.4,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162344701534152703020000012320712931880276159_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026152613035146803770000005007366900478879387_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162344701534152703020000012320712931880276159_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 474.9,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000026152613035146803770000005007366900478879387_)",
      fill: "#FFFFFF"
    },
    width: 47.2,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000131353566703827345300000008502791954667836845_",
    points: "563.4,1019.1 549.5,977.2 529.6,977.2  529.6,1030.3 542.2,1030.3 542.2,989.2 556,1030.3 576,1030.3 576,977.2 563.4,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131353566703827345300000008502791954667836845_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026843642101835874840000003302036488291322009_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131353566703827345300000008502791954667836845_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 528.1,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000026843642101835874840000003302036488291322009_)",
      fill: "#FFFFFF"
    },
    width: 49.4,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160874506698370532750000016994324063016894103_",
    x: 583.9,
    y: 977.2,
    width: 12.5,
    height: 53.1
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160874506698370532750000016994324063016894103_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164490089617365868420000014099189435887151775_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160874506698370532750000016994324063016894103_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 582.4,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000164490089617365868420000014099189435887151775_)",
      fill: "#FFFFFF"
    },
    width: 15.5,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127736643522956665000000017092306629441699751_",
    points: "604.3,1030.3 638.3,1030.3 638.3,1020.6  617.5,1020.6 617.5,1008.6 634.2,1008.6 634.2,998.8 617.5,998.8 617.5,987 638.3,987 638.3,977.2 604.3,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127736643522956665000000017092306629441699751_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147222358938377736160000012138516424042587018_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127736643522956665000000017092306629441699751_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 602.8,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000147222358938377736160000012138516424042587018_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000038372720819952890640000009418718706269427131_",
    points: "689.4,977.2 675.7,977.2 659.2,999.8  659.2,977.2 646.2,977.2 646.2,1030.3 659.2,1030.3 659.2,1016.7 664.5,1009.7 676.2,1030.3 690.4,1030.3 672,1000.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000038372720819952890640000009418718706269427131_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063590830594091200250000018150434589695837624_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000038372720819952890640000009418718706269427131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 644.7,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000063590830594091200250000018150434589695837624_)",
      fill: "#FFFFFF"
    },
    width: 47.2,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003105433767117111050000008956441339226377091_",
    points: "696,1030.3 730,1030.3 730,1020.6 709.2,1020.6  709.2,1008.6 725.9,1008.6 725.9,998.8 709.2,998.8 709.2,987 730,987 730,977.2 696,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003105433767117111050000008956441339226377091_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145772271278388545420000006232180787638955942_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003105433767117111050000008956441339226377091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 694.5,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000145772271278388545420000006232180787638955942_)",
      fill: "#FFFFFF"
    },
    width: 37,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052786841229825081250000007824145266134555290_",
    points: "771.8,1019.1 757.8,977.2 737.9,977.2  737.9,1030.3 750.5,1030.3 750.5,989.2 764.3,1030.3 784.4,1030.3 784.4,977.2 771.8,977.2  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052786841229825081250000007824145266134555290_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057842571364671657390000009051237153431939225_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052786841229825081250000007824145266134555290_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 736.4,
    y: 975.7,
    style: {
      clipPath: "url(#SVGID_00000057842571364671657390000009051237153431939225_)",
      fill: "#FFFFFF"
    },
    width: 49.4,
    height: 56.1
  })), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000097471236265053716180000012918928831174424487_",
    x: 37,
    y: 854,
    width: 751.9,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097471236265053716180000012918928831174424487_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121965661239030570070000002439766113221427866_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097471236265053716180000012918928831174424487_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 852.5,
    style: {
      clipPath: "url(#SVGID_00000121965661239030570070000002439766113221427866_)",
      fill: "#FFFFFF"
    },
    width: 754.9,
    height: 23.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetecbannerwithlogo);
export default __webpack_public_path__ + "static/media/meetecbannerwithlogo.7636befa2e09f9ffff46e0f77cbc7f43.svg";
export { ForwardRef as ReactComponent };